export const selectActualAPPIdKeyObject = (state) => state.appId.actualKey;
